import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface Bucket { label: string; value: number }
export interface DealerWise { dealerId: number; dealerName: string; orders: number; installations: number; outstanding: number; paid: number }

export interface ClientDashboard {
  orders: { total: number; pending: number; completed: number; value: number };
  installations: { total: number; pending: number; ongoing: number; completed: number };
  finance: { totalInvoiced: number; paid: number; outstanding: number };
  charts: { orderStatus: Bucket[]; installationStatus: Bucket[]; orderTrend: Bucket[]; financeTrend: Bucket[]; dealerPerformance: Bucket[] };
  dealerWise: DealerWise[];
}

export interface ClientFinance {
  totalInvoiced: number;
  paid: number;
  outstanding: number;
  overdue: number;
  ageing: Bucket[];
  dealerWise: Array<{ dealerId: number; dealerName: string; invoiced: number; paid: number; outstanding: number }>;
  invoices: Array<{ paymentCode: string; dealerName: string; amount: number; status: string; dueDate: string | null }>;
}

export interface PortalDealer { dealer_id: number; dealer_code: string; dealer_name: string; status: string }

export const clientPortalApi = {
  async dashboard(): Promise<ClientDashboard> {
    return (await apiClient.get<ApiSuccess<ClientDashboard>>('/client-portal/dashboard')).data.data;
  },
  async finance(): Promise<ClientFinance> {
    return (await apiClient.get<ApiSuccess<ClientFinance>>('/client-portal/finance')).data.data;
  },
  async dealers(): Promise<PortalDealer[]> {
    return (await apiClient.get<ApiSuccess<PortalDealer[]>>('/client-portal/dealers')).data.data;
  },
};
